var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { SubmissionDeadline } from "./../models/V1/SubmissionDeadlineConfigurations/SubmissionDeadline";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { SubmissionDeadlineConfiguration } from "./../models/V1/SubmissionDeadlineConfigurations/SubmissionDeadlineConfiguration";
import { SearchResult } from "./../models/V1/SubmissionDeadlineConfigurations/Search/SearchResult";
export class SubmissionDeadlineConfigurations {
  /**
   * Creates an instance of SubmissionDeadlineConfigurations.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof SubmissionDeadlineConfigurations
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetDeadlinesRq_ _getDeadlinesRq
   * @returns Promise<GetDeadlinesRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  getDeadlines(pGetDeadlinesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations/{id}/deadlines",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "id", value: pGetDeadlinesRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SubmissionDeadline, isArray: true },
        { statusCode: 401, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateDeadlinesRq_ _createDeadlinesRq
   * @returns Promise<CreateDeadlinesRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  createDeadlines(pCreateDeadlinesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations/{id}/deadlines",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "id", value: pCreateDeadlinesRq.id, required: true }]);
    client.addBody({ value: pCreateDeadlinesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201 },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 401, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateRq_ _createRq
   * @returns Promise<CreateRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  create(pCreateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pCreateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201, clazz: SubmissionDeadlineConfiguration },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 401, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SearchResult },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateAvailableRq_ _updateAvailableRq
   * @returns Promise<UpdateAvailableRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  updateAvailable(pUpdateAvailableRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations/{id}/available",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "id", value: pUpdateAvailableRq.id, required: true }]);
    client.addBody({ value: pUpdateAvailableRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 401, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateDeadlineRq_ _updateDeadlineRq
   * @returns Promise<UpdateDeadlineRq_>
   * @memberof SubmissionDeadlineConfigurations
   */
  updateDeadline(pUpdateDeadlineRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionDeadlineConfigurations/{deadlineConfigurationId}/deadlines/{deadlineId}",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "deadlineConfigurationId", value: pUpdateDeadlineRq.deadlineConfigurationId, required: true },
      { name: "deadlineId", value: pUpdateDeadlineRq.deadlineId, required: true }
    ]);
    client.addBody({ value: pUpdateDeadlineRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 401, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
